module.exports = __webpack_public_path__ + "media/images/common/limited_product_content_top_bg-768255b9736c25a5d6bba9269647e270.png";